var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_8955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12.9998V4.3331M9 4.3331C8.99999 4.02631 9.07055 3.72364 9.20623 3.44849C9.3419 3.17334 9.53906 2.93309 9.78244 2.74633C10.0258 2.55956 10.3089 2.43129 10.6098 2.37144C10.9107 2.31159 11.2213 2.32176 11.5176 2.40116C11.814 2.48056 12.0881 2.62707 12.3187 2.82935C12.5494 3.03163 12.7304 3.28426 12.8478 3.56769C12.9652 3.85113 13.0158 4.15777 12.9957 4.46389C12.9756 4.77002 12.8854 5.06742 12.732 5.3331M9 4.3331C9.00001 4.02631 8.92945 3.72364 8.79377 3.44849C8.6581 3.17334 8.46094 2.93309 8.21756 2.74633C7.97417 2.55956 7.69109 2.43129 7.3902 2.37144C7.08931 2.31159 6.77868 2.32176 6.48236 2.40116C6.18603 2.48056 5.91193 2.62707 5.68129 2.82935C5.45064 3.03163 5.26961 3.28426 5.15222 3.56769C5.03483 3.85113 4.98421 4.15777 5.00429 4.46389C5.02436 4.77002 5.11459 5.06742 5.268 5.3331M11 9.66643C10.4232 9.49782 9.91656 9.14685 9.556 8.6661C9.19544 8.18534 9.00036 7.6007 9 6.99976C8.99964 7.6007 8.80456 8.18534 8.444 8.6661C8.08344 9.14685 7.5768 9.49782 7 9.66643",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.998 4.41602C13.3899 4.51677 13.7537 4.70538 14.0619 4.96756C14.3701 5.22973 14.6146 5.5586 14.7768 5.92925C14.9391 6.2999 15.0149 6.70261 14.9985 7.10689C14.982 7.51117 14.8738 7.90641 14.682 8.26268",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12.9994C13.587 12.9994 14.1576 12.8057 14.6233 12.4483C15.089 12.091 15.4238 11.59 15.5757 11.023C15.7276 10.456 15.6882 9.85467 15.4636 9.31235C15.239 8.77002 14.8417 8.31696 14.3333 8.02344",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3126 12.6553C14.3594 13.0168 14.3315 13.384 14.2307 13.7343C14.1299 14.0846 13.9584 14.4105 13.7268 14.6919C13.4951 14.9733 13.2082 15.2043 12.8838 15.3704C12.5594 15.5366 12.2044 15.6346 11.8406 15.6582C11.4769 15.6818 11.1122 15.6306 10.769 15.5077C10.4259 15.3848 10.1115 15.1929 9.84546 14.9438C9.57937 14.6947 9.36718 14.3937 9.22199 14.0593C9.0768 13.725 9.00169 13.3644 9.0013 12.9999C9.00091 13.3644 8.9258 13.725 8.78061 14.0593C8.63542 14.3937 8.42323 14.6947 8.15714 14.9438C7.89105 15.1929 7.57672 15.3848 7.23356 15.5077C6.89039 15.6306 6.52568 15.6818 6.16195 15.6582C5.79822 15.6346 5.44319 15.5366 5.11878 15.3704C4.79437 15.2043 4.50748 14.9733 4.27582 14.6919C4.04416 14.4105 3.87266 14.0846 3.77189 13.7343C3.67113 13.384 3.64325 13.0168 3.68997 12.6553",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00053 12.9994C4.41353 12.9994 3.84294 12.8057 3.37725 12.4483C2.91155 12.091 2.57678 11.59 2.42485 11.023C2.27292 10.456 2.31232 9.85467 2.53695 9.31235C2.76157 8.77002 3.15886 8.31696 3.6672 8.02344",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.0026 4.41602C4.61074 4.51677 4.24694 4.70538 3.93876 4.96756C3.63058 5.22973 3.3861 5.5586 3.22383 5.92925C3.06157 6.2999 2.98578 6.70261 3.0022 7.10689C3.01862 7.51117 3.12682 7.90641 3.3186 8.26268",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_8955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrain);
export default __webpack_public_path__ + "static/media/brain.c21bf5879bbc2c930532f87525d89e53.svg";
export { ForwardRef as ReactComponent };